<template>
  <div>
    <v-dialog 
    :value="updateExists" 
    persistent 
    max-width="500"
  >
    <v-card class="pa-6 text-center" color="#2B2B2A">
      <v-card-title class="justify-center headline white--text">
        SEQITracker wird aktualisiert
      </v-card-title>

      <v-card-text class="white--text">
        Eine neue Version wird installiert. Die Anwendung startet in Kürze neu, um die Änderungen zu übernehmen.
      </v-card-text>

      <v-progress-circular
        indeterminate
        color="#f44336"
        size="64"
        class="mb-4"
      ></v-progress-circular>
    </v-card>
  </v-dialog>

  <v-snackbar v-model="showSuccess" bottom :timeout="5000">
      SEQITracker erfolgreich aktualisiert!
      <template v-slot:action="{ attrs }">
        <v-btn text class="red--text" v-bind="attrs" @click="showSuccess = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
// https://dev.to/drbragg/handling-service-worker-updates-in-your-vue-pwa-1pip
export default {
  data() {
    return {
      // refresh variables
      refreshing: false,
      registration: null,
      updateExists: false,
      showSuccess: false
    };
  },

  created() {
    // Check if we have just updated
    if (localStorage.getItem('pwa_update_success') === 'true') {
      this.showSuccess = true;
      localStorage.removeItem('pwa_update_success');
    }

    // Listen for our custom event from the SW registration
    document.addEventListener('swUpdated', this.updateAvailable, {
      once: true
    });

    // Prevent multiple refreshes
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (this.refreshing) {
        return
      }
      this.refreshing = true;
      // Here the actual reload of the page occurs
      window.location.reload();
    });
  },

  methods: {
    // Store the SW registration so we can send it a message
    // We use `updateExists` to control whatever alert, toast, dialog, etc we want to use
    // To alert the user there is an update they need to refresh for
    updateAvailable(event) {
      this.registration = event.detail;
      this.updateExists = true;
      this.refreshApp();
    },

    // Called when the user accepts the update
    refreshApp() {
      // Make sure we only send a 'skip waiting' message if the SW is waiting
      if (!this.registration || !this.registration.waiting) {
        return
      } else {
        localStorage.setItem('pwa_update_success', 'true');
        // send message to SW to skip the waiting and activate the new SW
        setTimeout(() => {
          this.registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        }, 7000)
      }
    }
  }
};
</script>

<style>
</style>